import React, {useEffect, useState} from "react";
import { Button, Col, FormGroup, Modal, Row, Container} from "react-bootstrap";
import { Form, Checkbox ,Input, Select } from 'antd';
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
import { Link } from "react-router-dom";
const handleChange = (value) => {
    console.log(`selected ${value}`);
};


function BookAppointment() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider List',
        },
    ];
    // Modal
    const [showRequested, setRequested] = useState(false);
    const RequestedClose = () => setRequested(false);
    const RequestedShow = () => {setRequested(true)};

    const [emergencyFreeOld, setemergencyFreeOld] = useState(false);
    const emergencyFreeOldClose = () => setemergencyFreeOld(false);
    const emergencyFreeOldShow = () => {
        RequestedClose(false);
        setemergencyFreeOld(true);
    }

    const [showloader, setloader] = useState(false);
    const loaderShow = () => setloader(true);
    const [show, setShow] = useState(false);
    const [bookingType, setBookingType] = useState();
    const handleClose = () => {
        setShow(false);
        setloader(true);
    };
    const handleClose2 = () => {
        setShow(false);
        setloader(false);
    };
    const loaderClose = () => {
        document.querySelector('body').classList.remove('overflow-hidden');
        setloader(false)
    }
    const handleShow = (type) => {
        setBookingType(type)
        setShow(true)
    };
    const { TextArea } = Input;
    useEffect(() => {
        if(showloader){
            document.querySelector('body').classList.add('overflow-hidden');
        }else{
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    });
    return(
        <>            
            <LoginHeader/>         
            <div className="main-content BookAppointmentPage dashboardPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Book Appointment" breadcrumb={breadcrumb}/>
                        {/* Service Address */}
                        <div className="serviceAddress bg-white p-30 br-10">
                            <div className="d-flex align-items-lg-center align-items-start flex-lg-row flex-column">
                                <div className="serviceAddress_left">
                                    <h2 className="font-sm">Service Address</h2>
                                    <p className="mb-0 font-md">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                </div>
                                <div className="serviceAddress_right ms-lg-auto">
                                    <div className="d-flex align-items-center">
                                        <Form>
                                            <FormGroup className="form-group d-flex align-items-sm-center mb-0">
                                                <Form.Item label="Sort By" className="mb-0 font-md" >
                                                    <Select defaultValue="serviceProvider1"
                                                        onChange={handleChange} className="w-100 ant-select-lg"
                                                        options={[
                                                            {
                                                            value: 'serviceProvider1',
                                                            label: 'All Service Provider',
                                                            },
                                                            {
                                                            value: 'serviceProvider2',
                                                            label: 'Favorite Service Provider',
                                                            },
                                                        ]}
                                                        />
                                                </Form.Item>
                                                <Button variant="primary" type="submit" className="font-md ms-sm-2" onClick={() => handleClose()}>Emergency Request to all</Button>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Service Address */}
                        <div className="appointmentSection bg-white p-30 br-10">
                            <Row className="g-3">
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative"> 
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                        <ul className="list-unstyled d-flex starRating mb-0">
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                        </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>  
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                        <ul className="list-unstyled d-flex starRating mb-0">
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                        </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={() => handleShow(1)} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                        <ul className="list-unstyled d-flex starRating mb-0">
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                        </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                        <ul className="list-unstyled d-flex starRating mb-0">
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                        </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-5.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-5.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                            </Row>
                        </div>                        
                    </Container>
                    <div className={`thankyouloader ${!showloader && 'd-none'}`}>
                        <div className="thankyouloader_content">
                            <h2>Thank you for choosing us!</h2>
                            <div className="thankyouloader_sec d-flex justify-content-center align-items-center mx-auto">    
                                <Link to="">
                                    <ImageElement source="loader-img.svg" />
                                </Link>  
                            </div>  
                            <Link onClick={() => RequestedShow()} className="thankyouloader_closebtn d-flex justify-content-center align-items-center"> 
                                <em className="gg-close"></em>                               
                            </Link>                                         
                        </div>
                    </div>
                </div>
            </div>
             {/* add location */}
             <Modal show={show} onHide={handleClose2} size="lg" centered id="addLocation" className="bookingDetails" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="promoCode">
                        <Form className="d-flex align-items-end">
                            <FormGroup className="form-group promoCode_wrapper mb-0">
                                    <label className="ant-label font-md">Promo Code</label>
                                <Input size="large" placeholder="Promo Code" value="NIT" />
                            </FormGroup>
                            <Button variant="primary" type="submit" className="ms-2 font-sm d-inline-block">APPLY</Button>
                        </Form>
                        <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2"/> <span>Promo Code applied!</span></div>
                    </div>
                    <FormGroup className="form-group">
                        <label className="ant-label font-md ps-0">Add Special Instruction For Provider Below</label>
                        <TextArea rows={5} />
                    </FormGroup>
                    <Button variant="primary" className="ms-auto min-200 mt-lg-4 mt-3" onClick={() => handleClose()}>Book Now</Button>
                </Modal.Body>
            </Modal>
                {/* booking requested */}
                <Modal show={showRequested} onHide={RequestedClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Confirmation</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p>This will cancel your booking request. We will have you updated in less than a minute. Are you sure you want to cancel ?</p>
                    </div>
                    <div className="d-flex justify-content-end align-items-end chooseBookingmodal_button">
                        <Button  className="btn btn-light" onClick={RequestedClose}>CANCEL</Button>
                        {
                            bookingType === 1 ?
                            <Link className="btn btn-primary ms-3" onClick={() => (RequestedClose(), setloader(false))}>Confirm</Link>
                            : 
                            <Link className="btn btn-primary ms-3" onClick={emergencyFreeOldShow}>Confirm</Link>
                        }
                    </div>  
                </Modal.Body>
            </Modal> 
            {/* requesting */}
            <Modal show={emergencyFreeOld} onHide={emergencyFreeOldClose} size="lg" centered id="paidemergencyFreeOld" className="paidemergencyFreeOldmodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>REQUESTING</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidemergencyFreeOld">
                        <p>This is a live same day service request sent directly to our technicians. We will confirm your appointment shortly under “My Bookings”.</p>
                    </div>
                    <div className="d-flex justify-content-end">    
                        <Link to="/my-bookings" className="btn btn-primary min-200">UPCOMING BOOKINGS</Link>
                    </div>
                </Modal.Body>
            </Modal>
            {/* thank you for choosing us */}
        </>
    );
}

export default BookAppointment;